import { api } from '@/api';
import { queryOptions } from '@tanstack/react-query';

/**
 * 본인 프로필 — 사용자 메뉴 표시용. 응답 필드는 코어 스펙에 정의돼 있지 않아 unknown으로 받고
 * parseProfile이 방어적으로 읽는다. 실패해도 화면을 막지 않고 기본 표기("내 계정")로 둔다.
 * 세션이 바뀌면 clearOperationalCache가 이 캐시도 비운다.
 */
export const profileQuery = queryOptions({
  queryKey: ['auth', 'me'],
  queryFn: ({ signal }) => api.core.get<unknown>('users/me', { signal }),
  staleTime: 5 * 60_000,
  retry: false,
  meta: { suppressGlobalError: true },
});
